module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ok":"Close","title":"Guidance for a good explanation"},"nl":{"ok":"Sluiten","title":"Handleiding voor een goede verklaring"}}')
  delete Component.options._Ctor
}
